import React from 'react'

const PermissionContext = React.createContext(
  {}
)

export default PermissionContext
